import { createStyles, INPUT_SIZES } from '@mantine/core';
var inputSizes = {
  xs: 20,
  sm: 23,
  md: 25,
  lg: 27,
  xl: 29
};
var useStyles = createStyles(function (theme, _ref) {
  var size = _ref.size;
  return {
    disabled: {
      opacity: 0.6,
      cursor: "not-allowed"
    },
    controls: {
      display: "flex",
      alignItems: "center",
      height: theme.fn.size({
        size: size,
        sizes: INPUT_SIZES
      }) - 2
    },
    timeInput: {
      width: theme.fn.size({
        size: size,
        sizes: inputSizes
      }),
      appearance: "none",
      backgroundColor: "transparent",
      color: "inherit",
      padding: 0,
      textAlign: "center",
      border: "1px solid transparent",
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      lineHeight: 1,
      outline: 0,
      "&[disabled]": {
        color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
        cursor: "not-allowed"
      }
    }
  };
});
export default useStyles;
export { inputSizes };